import axios from "axios";
export default axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://api.triomarkets.com",
});
